/**
 * 首页
 */

import { HTTP_ALB } from '../axios'

//  核心数据
export const getHomeCore = params => {
  return HTTP_ALB.get('/home/home/core', params)
}

//  核心数据
export const getIndustryColumn = params => {
  return HTTP_ALB.get('/foundation/industry/column', params)
}

// 正在直播数据
export const getHomeLive = params => {
  return HTTP_ALB.get('/home/home/live', params)
}
// 授权异常直播间数据
export const getHomeAuth = params => {
  return HTTP_ALB.get('/home/home/auth', params)
}

// 主播跟进数据
export const getHomeFace = params => {
  return HTTP_ALB.get('/home/home/face', params)
}

// 主播排行榜
export const getHomeAnchor = params => {
    return HTTP_ALB.get('/home/home/anchor', params)
}

// 直播间排行榜
export const getHomeLiverank = params => {
  return HTTP_ALB.get('/home/home/liverank', params)
}

// 直播间跟进
export const liveFace = params => {
  return HTTP_ALB.get('/home/home/liveface', params)
}

  
